import React, {useEffect, useLayoutEffect, useState} from 'react';

const getBoundingClientRect = element => {
    const {top, right, bottom, left, width, height, x, y} = element?.getBoundingClientRect() || {};
    return {top, right, bottom, left, width: width, height, x, y};
}

export function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export function useElRect(el) {

    let feetToEl;

    while (1) {
        feetToEl = (feetToEl || el)?.parentElement;
        if (!feetToEl || feetToEl.style.overflow === "auto" || feetToEl.style.overflowY === "auto" || feetToEl.nodeName.toLowerCase() === "body") {
            break;
        }
    }

    const [rect, setRect] = useState({
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0,
        feetToElWidth: 0,
        feetToElHeight: 0,
        elWidth: 0,
        elHeight: 0,
        elOffsetWidth: 0,
        elOffsetHeight: 0,
        elScrollWidth: 0,
        elScrollHeight: 0
    });
    useEffect(() => {
        function updateSize() {
            const feetToElWidth = feetToEl?.clientWidth || 0;
            const feetToElHeight = feetToEl?.clientHeight || 0;
            const elWidth = el?.clientWidth || 0;
            const elHeight = el?.clientHeight || 0;
            const elOffsetWidth = el?.offsetWidth || 0;
            const elOffsetHeight = el?.offsetHeight || 0;
            const elClientWidth = el?.clientWidth || 0;
            const elClientHeight = el?.clientHeight || 0;

            const elRect = getBoundingClientRect(el);
            setRect({...rect, ...elRect, feetToElWidth, feetToElHeight, elWidth, elHeight, elOffsetWidth, elOffsetHeight, elScrollWidth: elOffsetWidth - elClientWidth});
        }
        window.addEventListener('resize', updateSize);
        el?.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, [el]);

    return rect;
}

export function useGetElRect(elRef) {

    const [rect, setRect] = useState(null);

    useEffect(() => {

        function updateSize() {
            if (elRef?.current) {
                const elRect = getBoundingClientRect(elRef?.current);
                setRect(elRect);
            }
        }
        window.addEventListener('resize', updateSize);
        elRef?.current?.addEventListener('resize', updateSize);
        updateSize();
        return () => {
            window.removeEventListener('resize', updateSize);
            elRef?.current?.removeEventListener('resize', updateSize);
        };
    }, [elRef?.current]);

    return rect;
}

export const useOutsideRefClick = (ref, callback, exceptions) => {

    const outsideClickHandler = (e) => {
        let clickInside  = ref?.current?.contains(e.target) || ref?.current?.contains(e.target);

        const isInException = exceptions.some(selector =>
            e.target.closest(selector)
        );

        if (!clickInside && !isInException) {
            callback();
        }
    }

    useEffect(() => {
        if (ref?.current && typeof(callback) === "function") {
            document.addEventListener("mouseup", outsideClickHandler);
            return () => {
                document.removeEventListener("mouseup", outsideClickHandler);
            };
        }
    }, [ref?.current]);
};

export const useOutsideClick = (callback) => {

    useEffect(() => {
        if (typeof(callback) === "function") {
            document.addEventListener("mousedown", callback);
            return () => {
                document.removeEventListener("mousedown", callback);
            };
        }
    }, []);
};

export default useOutsideClick;